import { useCallback, useEffect, useRef, useState } from "react";
import { Button, notification, Popconfirm, Tooltip } from "antd";
import { useGetColumnSearchProps } from "../../../../../hooks/FilterTable/stringCLearFiltros";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import OthersService from "../../../../../services/http/services/Acessos/OthersService";
import { useGetColumnSearchPropsData } from "../../../../../hooks/FilterTable/date";
import moment from "moment";
import { AcessoModulo, IAcessoById } from "../../interface";
import { IReqModulos } from ".";

const opcaoTodosModulos = {
    "id": 0,
    "uuid": "string",
    "createdAt": "string",
    "updatedAt": "string",
    "nome": "Todos",
    "descricao": "Todos",
    "path": "Todos",
    "modoEstado": false,
    "modoMunicipio": false,
    "restritoAlgunsEstados": false,
    // "estados": null|não sei o que vem
}

interface IDadosTabela {
    id: number;
    descricao: string;
    validade_degustacao: string | null;
}


interface IProps {
    funcSetValorModulosDegustacao: any;
    dataAcessosEdit: IAcessoById | undefined;
    idPlano?: number | string;
}

export const useModulosDegustacao = (props: IProps) => {


    const isDataAcessoEdit = useRef<boolean>(false);
    const refFuncaoLimparFiltrosString = useRef<any>(null);

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<IDadosTabela>>([]);
    const refDadosTabelaBackup = useRef<Array<IDadosTabela>>([]);
    const refDadosTabela = useRef<Array<IDadosTabela>>([]);

    const [loadingTable, setloadingTable] = useState(false);
    const [loadingModal, setloadingModal] = useState(false);

    const refFormModal = useRef<any>(null);
    const [openModal, setOpenModal] = useState(false);

    const [loadingModalModulos, setloadingModalModulos] = useState(false);
    const [reqDadosModulos, setReqDadosModulos] = useState<Array<IReqModulos>>([]);
    const refAllReqDadosModulos = useRef<Array<IReqModulos>>([]);

    const [isEdit, setIsEdit] = useState(false);

    const [selectedDateValidade, setSelectedDateValidade] = useState<any>(null);

    const columnSearchPropsNome = useGetColumnSearchProps('descricao', refFuncaoLimparFiltrosString);
    const columnSearchPropsDataDegustacao = useGetColumnSearchPropsData('vigencia_acesso');

    //para poder cancelar a requisição
    const signal = axios.CancelToken.source();

    //executa apenas quando desmonta o component
    useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
    }, []);

    const filtrarModulosNaoNaTabela = useCallback((
        dadosTabela: IDadosTabela[],
        todosModulos: IReqModulos[]
    ): IReqModulos[] => {
        return todosModulos.filter(modulo =>
            !dadosTabela.some(dado => dado.id === modulo.id)
        );
    }, []);

    const getModulosDegustacaoByIdPlano = useCallback((idPlano: number | string) => {
        const requestAsync = async () => {
            try {
                setloadingModalModulos(true);

                let data = await OthersService.getModulosDegustacaoByIdPlano(idPlano, signal.token)

                refAllReqDadosModulos.current = data

                setloadingModalModulos(false);

                return data;
            } catch (error) {
                setloadingModalModulos(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });

                return
            }
        }

        return requestAsync();
    }, []);

    const getModulosDegustacao = useCallback((idPlano: number | string) => {

        const requestAsync = async () => {
            setloadingModalModulos(true);
            try {

                let data = await getModulosDegustacaoByIdPlano(idPlano) || []

                const opcaoTodos: IReqModulos = opcaoTodosModulos

                const dadosUnicos = [
                    ...refDadosTabelaBackup.current,
                    ...refDadosTabela.current.filter(
                        (item) => !refDadosTabelaBackup.current.some((backupItem) => backupItem.id === item.id)
                    )
                ];

                isDataAcessoEdit.current = false
                if (dadosUnicos.length === 0) {

                    // Adiciona "Todos" apenas se ainda não estiver na lista
                    setReqDadosModulos((prevState) => {
                        const novaLista = [opcaoTodos, ...data]; // Garante que "Todos" sempre esteja na frente
                        return novaLista;
                    });

                    setloadingModalModulos(false);
                    return true
                }

                if (dadosUnicos.length != 0) {

                    const tabela = dadosUnicos.filter((table) => {
                        return data.some(dado => dado.id === table.id)
                    })

                    refDadosTabela.current = tabela

                    setDadosTabelaState(tabela);

                    const modulosForaDaTabela = filtrarModulosNaoNaTabela(
                        refDadosTabela.current,
                        refAllReqDadosModulos.current
                    );

                    const opcaoTodos: IReqModulos = opcaoTodosModulos
                    setReqDadosModulos((prevState) => {
                        const novaLista = [opcaoTodos, ...modulosForaDaTabela]; // Garante que "Todos" sempre esteja na frente
                        return novaLista;
                    });

                    setloadingModalModulos(false);
                    return true
                }

            } catch (error) {
                isDataAcessoEdit.current = false
                setloadingModalModulos(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        requestAsync();

    }, []);


    useEffect((): any => {

        refFormModal.current?.setFieldsValue(
            { validade_degustacao: selectedDateValidade, }
        );

    }, [selectedDateValidade]);

    useEffect((): any => {

        props.funcSetValorModulosDegustacao(dadosTabelaState)

    }, [dadosTabelaState]);

    useEffect((): any => {

        if (props?.idPlano && !isDataAcessoEdit.current) {
            getModulosDegustacao(props.idPlano);
        }

    }, [props.idPlano]);

    const transformEditForTable = useCallback((dataAllModulos: AcessoModulo[]): IDadosTabela[] => {
        return dataAllModulos.map(item => ({
            id: item.id,
            descricao: item.descricao,
            validade_degustacao: item.validade_degustacao
        }));
    }, []);

    useEffect((): any => {

        const requestAsync = async () => {
            try {

                if (props.dataAcessosEdit) {
                    isDataAcessoEdit.current = true
                    if (refDadosTabela.current.length === 0) {

                        const tabela = transformEditForTable(props.dataAcessosEdit.modulos_degustacao)

                        refDadosTabelaBackup.current = tabela
                        refDadosTabela.current = tabela

                        setDadosTabelaState(tabela);

                        getModulosDegustacao(props.dataAcessosEdit.planoId)

                        // await getModulosDegustacaoByIdPlano(props.dataAcessosEdit.planoId)

                        // const modulosForaDaTabela = filtrarModulosNaoNaTabela(
                        //     refDadosTabela.current,
                        //     refAllReqDadosModulos.current
                        // );

                        // const opcaoTodos: IReqModulos = opcaoTodosModulos
                        // setReqDadosModulos((prevState) => {
                        //     const novaLista = [opcaoTodos, ...modulosForaDaTabela]; // Garante que "Todos" sempre esteja na frente
                        //     return novaLista;
                        // });
                    }
                }


            } catch (error) {
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        requestAsync();

    }, [props.dataAcessosEdit]);



    const transformArraySaveAll = useCallback((dataAllModulos: IReqModulos[], data: string | null): IDadosTabela[] => {
        return dataAllModulos.map(item => ({
            id: item.id,
            descricao: item.descricao,
            validade_degustacao: data
        }));
    }, []);

    const selectModuloPorID = useCallback((id): IReqModulos | null => {
        let modulo = null;
        refAllReqDadosModulos.current.forEach(val => {
            if (val.id == id) {
                modulo = val
            }
        });
        return modulo;
    }, []);

    const clickSubmitModal = useCallback((saveOnClose = true): void => {

        const requestAsync = async (values: IDadosTabela) => {
            setloadingModal(true);
            try {
                if (values.id === 0) {
                    // Se "Todos" for selecionado, adiciona TODOS os itens da referência no estado
                    const newObj = transformArraySaveAll(refAllReqDadosModulos.current, values.validade_degustacao);

                    setReqDadosModulos([opcaoTodosModulos])
                    setDadosTabelaState(newObj)
                    refDadosTabela.current = newObj
                } else {

                    // // Remove o item do estado `reqDadosModulos` caso já exista um com o mesmo ID
                    setReqDadosModulos((prevState) => prevState.filter(item => item.id !== values.id));

                    setDadosTabelaState((prevState) => {
                        const index = prevState.findIndex(item => item.id === values.id);

                        if (index !== -1) {
                            // Se já existe, substitui o item na posição correta
                            const novoEstado = [...prevState];
                            novoEstado[index] = values;
                            return novoEstado;
                        } else {
                            // Se não existe, adiciona ao array
                            return [...prevState, values];
                        }
                    });

                    // Atualiza a ref também
                    const indexRef = refDadosTabela.current.findIndex(item => item.id === values.id);
                    if (indexRef !== -1) {
                        refDadosTabela.current[indexRef] = values;
                    } else {
                        refDadosTabela.current = [...refDadosTabela.current, values];
                    }
                }


                if (saveOnClose) {
                    clickCancelModalFiltros();
                } else {
                    refFormModal.current.setFieldsValue(
                        {
                            id: null,
                            descricao: null,
                        }
                    );
                }

                setloadingModal(false);

            } catch (error) {
                setloadingModal(false);

                setloadingModal(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        refFormModal?.current?.validateFields()
            .then((values: any) => {
                // let validade = convertDataBrParaUS(values.validade_degustacao);
                let validade = moment(values.validade_degustacao, 'DD/MM/YYYY', true)
                    .startOf('day')
                    .toDate();

                values.validade_degustacao = validade ? validade : null;

                values.descricao = selectModuloPorID(values.id)?.descricao

                requestAsync(values);

            })
            .catch((errorInfo: any) => {
                setloadingModal(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, [dadosTabelaState]);

    const clickCancelModalFiltros = useCallback((): void => {

        setSelectedDateValidade(null);
        setOpenModal(false);
        setIsEdit(false);
    }, []);

    const clickOpenModalFiltros = useCallback((): void => {

        if (!props?.idPlano) {
            notification.error({
                message: 'Erro',
                description:
                    'Por favor, selecione um plano.',
            });
            return
        }
        setOpenModal(true);
    }, [props?.idPlano]);

    const clickRemoveOneModuloDegustacao = useCallback((modulo: IDadosTabela): void => {

        refDadosTabela.current = refDadosTabela.current.filter(item => item.id !== modulo.id);

        setDadosTabelaState((prevState) => prevState.filter(item => item.id !== modulo.id));

        const modulosForaDaTabela = filtrarModulosNaoNaTabela(
            refDadosTabela.current,
            refAllReqDadosModulos.current
        );

        const opcaoTodos: IReqModulos = opcaoTodosModulos
        setReqDadosModulos((prevState) => {
            const novaLista = [opcaoTodos, ...modulosForaDaTabela]; // Garante que "Todos" sempre esteja na frente
            return novaLista;
        });

    }, []);

    const clickEDITAROneModuloDegustacao = useCallback((modulo: IDadosTabela): void => {

        //acrecentar obj no select
        setReqDadosModulos((prevState) => {
            const index = refAllReqDadosModulos.current.findIndex(item => item.id === modulo.id);

            if (index !== -1) {
                return [...prevState, refAllReqDadosModulos.current[index]];
            } else {
                return prevState
            }
        });

        setSelectedDateValidade(moment(modulo.validade_degustacao));
        setIsEdit(true);

        clickOpenModalFiltros();

        setTimeout(() => {
            refFormModal.current?.setFieldsValue(
                {
                    id: modulo.id,
                    descricao: modulo.descricao,
                }
            );
        }, 500);

    }, [props?.idPlano]);

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'descricao',
            ...columnSearchPropsNome,
        },
        {
            title: 'Validade',
            dataIndex: 'validade_degustacao',
            ...columnSearchPropsDataDegustacao,
            // width: '5%',
            showSorterTooltip: false,
            sorter: (a: any, b: any): any => {

                let aMonMen: number = 0
                let bMonMen: number = 0
                if (a?.validade_degustacao) {
                    aMonMen = moment(a.validade_degustacao).unix()
                } else {
                    aMonMen = 0
                }
                if (b?.validade_degustacao) {
                    bMonMen = moment(b.validade_degustacao).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            render: (validade_degustacao: any): any => {
                let data: any = null;
                if (validade_degustacao) {
                    data = moment(validade_degustacao).format('DD/MM/YYYY')
                }
                return (
                    data
                )
            },
        },
        {
            title: 'Ações',
            dataIndex: 'excluir',
            width: '120px',
            render: (text: any, record: any) => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                >
                    <Tooltip title="Editar" color="gold" key="editargold">
                        <Button
                            type="primary"
                            style={{
                                marginRight: 5
                            }}
                            className="btn_warning_Acessos_fewuybcoqbfvcqow"
                            onClick={() => clickEDITAROneModuloDegustacao(record)}
                        >
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    {
                        dadosTabelaState.length >= 1 ? (
                            <Popconfirm
                                title="Deseja realmente excluir?"
                                onConfirm={() => clickRemoveOneModuloDegustacao(record)}
                                onCancel={() => { }}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Tooltip title="Deletar" color="red" key="excluirRed">
                                    <Button
                                        type="primary"
                                        danger
                                    // onClick={() => {
                                    //     if (estaEditandoUsuario) {
                                    //         Modal.confirm({
                                    //             className: 'classmodalDadosContatoInatendimento',
                                    //             title: 'Atenção',
                                    //             icon: <ExclamationCircleOutlined />,
                                    //             content: `Todos usuários vinculados a está cidade deste contrato \n
                                    //          irão perder o acesso, deseja realmente excluir?`
                                    //             ,
                                    //             okText: 'Sim',
                                    //             okType: 'danger',
                                    //             cancelText: 'Cancelar',
                                    //             onOk() {
                                    //                 excluirDaTabela(record)
                                    //             },
                                    //             onCancel() {
                                    //             },
                                    //         });
                                    //     } else {
                                    //         excluirDaTabela(record)
                                    //     }
                                    // }}
                                    >
                                        <DeleteOutlined />
                                    </Button>
                                </Tooltip>
                            </Popconfirm>
                        ) : null
                    }
                </div>
            )
        },
    ];

    const clickRemoveAllModulosDegustacao = useCallback((): void => {
        const opcaoTodos: IReqModulos = opcaoTodosModulos
        setReqDadosModulos((prevState) => {
            const novaLista = [opcaoTodos, ...refAllReqDadosModulos.current]; // Garante que "Todos" sempre esteja na frente
            return novaLista;
        });
        setDadosTabelaState([])
        refDadosTabela.current = []
    }, []);


    return {
        clickOpenModalFiltros,
        clickRemoveAllModulosDegustacao,
        dadosTabelaState,
        loadingTable,
        columns,
        openModal,
        clickSubmitModal,
        clickCancelModalFiltros,
        loadingModal,
        isEdit,
        refFormModal,
        loadingModalModulos,
        reqDadosModulos,
        selectedDateValidade,
        setSelectedDateValidade,
    }
}
